
import React from 'react';
import { createPortal } from 'react-dom';
import { FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

/**
 * Premium Assessment Popup Component
 * Replaces SweetAlert2 with a unified design system.
 */
const AssessmentPopup = ({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  onBackdropClick,
  confirmText = "Confirm", 
  cancelText = "Cancel",
  type = "warning", // warning, success, info
  showCancel = true,
  showCloseButton = true,
  closeOnBackdrop = true,
  showInput = false,
  inputValue = "",
  onInputChange = () => {},
  inputPlaceholder = "Enter text...",
  containerClassName = "",
  showIcon = true,
  align = "center",
  children
}) => {
  if (!isOpen) return null;

  const handleClose = closeOnBackdrop ? (onBackdropClick || onCancel) : undefined;

  return createPortal(
    <div className="assessment-popup-overlay" onClick={handleClose}>
      <div className={`assessment-popup-container ${align === 'left' ? 'assessment-popup-align-left' : ''} ${containerClassName}`} onClick={e => e.stopPropagation()}>
        {showCloseButton && (
          <button 
            type="button"
            className="absolute top-6 right-6 text-slate-400 hover:text-slate-600 transition-colors bg-transparent border-0 cursor-pointer p-0"
            onClick={onCancel || onBackdropClick}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        {showIcon && (
          <div className={`assessment-popup-icon ${type}`}>
            {type === 'warning' && <FiAlertCircle />}
            {type === 'success' && <FiCheckCircle />}
            {type === 'info' && <FiInfo />}
          </div>
        )}
        <h3 className="assessment-popup-title">{title}</h3>
        <p className="assessment-popup-message">{message}</p>

        {showInput && (
          <input 
            type="text"
            className="w-full bg-[#f8fafc] border border-slate-100 rounded-2xl px-5 py-3 text-[12px] font-black text-[#1e293b] focus:ring-4 focus:ring-red-50 outline-none transition-all placeholder:text-slate-300 shadow-inner mb-8"
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder={inputPlaceholder}
            autoFocus
          />
        )}

        {children}

        <div className="assessment-popup-actions">
          {showCancel && (
            <button 
              className="btn-assessment btn-assessment-secondary"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button 
            className={`btn-assessment ${type === 'warning' ? 'btn-assessment-danger' : 'btn-assessment-primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssessmentPopup;
